<template>
  <div class="accounts-container">

    <div class="warning">
      <div v-if="showWarning">
        <div class="exclamation"></div>
        <div>Your Demo Account Request is being processed. Final status will be notiﬁed at your email.</div>
      </div>
    </div>

    <div class="account-selector" >
      <div class="options" :class="{'selected-type': selectedAccountType === 'TRADING'}" @click="selectAccount('TRADING')">Trading accounts</div>
      <div class="options" :class="{'selected-type': selectedAccountType === 'DEMO'}" @click="selectAccount('DEMO')">Demo accounts</div>
      <div class="spacer"></div>
      <button @click="createAccount" >+ Create new account</button>
    </div>

    <div class="accounts-table-container">
      <table class="accounts-table">
        <tr :class="{'has-rows': rows.length > 0}">
          <th class="table-header-cell" v-for="item in header" :key="item">{{ item }}</th>
        </tr>
        <!--      <div class="division"></div>-->
        <tr v-for="row in rows" :key="row.account">
          <td class="table-cell">{{ row.account }}</td>
          <td class="table-cell">{{ row.download }}</td>
          <td class="table-cell">{{ row.status }}</td>
          <td class="table-cell">{{ row.leverage }}</td>
          <td class="table-cell">{{ row.balance }}</td>
          <td class="table-cell">{{ row.margin }}</td>
          <td class="table-cell">{{ row.currency }}</td>
          <td class="table-cell"><button class="row-column red-button" @click="fund">Fund</button></td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
export default {
  name: "Accounts",
  data() {
    return {
      selectedAccountType: 'TRADING',
      header: [
        'ACCOUNT #',
        'DOWNLOAD',
        'STATUS',
        'LEVERAGE',
        'BALANCE',
        'FREE MARGIN',
        'CURRENCY',
        ''
      ],
      rows: [],
      showWarning: false
    };
  },
  created () {
    this.selectAccount('TRADING')
  },
  methods: {
    createAccount() {
      console.log('createAccount()');
    },
    fund() {
      this.showWarning = true
    },
    selectAccount(account) {
      this.selectedAccountType = account

      if (account === 'TRADING') {
        this.rows = [
          {
            'account': '1155',
            'download': 'download',
            'status': 'Active',
            'leverage': 0.00,
            'balance': 0.00,
            'margin': 0.00,
            'currency': 'USD'
          }
        ]
      }

      if (account === 'DEMO') {
        this.rows = [
        ]
      }
    }
  }
}
</script>
